import React from "react";

export default function Tabs({ tabs, active, onChange }) {
  return (
    <div
      style={{
        display: "flex",
        gap: 8,
        padding: "6px 10px 8px 10px",
        borderTop: "1px solid #333",
        borderBottom: "1px solid #333",
        background: "#232429",
        position: "relative",
        zIndex: 1,
      }}
    >
      {tabs.map((name) => (
        <button
          key={name}
          onClick={() => onChange(name)}
          style={{
            appearance: "none",
            background: active === name ? "#2b2c31" : "transparent",
            border: "1px solid " + (active === name ? "#3a3b40" : "transparent"),
            borderBottom: active === name ? "2px solid #ffc73c" : "1px solid transparent",
            color: "#eee",
            padding: "8px 10px",
            borderRadius: 10,
            fontWeight: 700,
            cursor: "pointer",
          }}
        >
          {name}
        </button>
      ))}
    </div>
  );
}
